// Password strength rules mirrored from prowatchly_api's `PasswordMixin`
// (modules/auth/auth_schemas.py). Client-side check is UX-only — the BE
// re-validates every password endpoint. We surface the same rule set so
// the operator doesn't burn a round-trip on a missing digit.

const MIN_LENGTH = 8;
const MAX_LENGTH = 100;

/** Error message if any rule fails, else null. Strings match the BE's
 *  `ValueError` text so logs stay consistent across client + server. */
export const validatePasswordStrength = (password: string): string | null => {
  if (password.length < MIN_LENGTH) return `Password must be at least ${MIN_LENGTH} characters long`;
  if (password.length > MAX_LENGTH) return `Password must be at most ${MAX_LENGTH} characters long`;
  if (!/\d/.test(password)) return 'Password must contain at least one digit';
  if (!/[A-Z]/.test(password)) return 'Password must contain at least one uppercase letter';
  if (!/[a-z]/.test(password)) return 'Password must contain at least one lowercase letter';
  return null;
};

/** Per-rule rows for an inline strength checklist. Re-evaluate as the user types. */
export const PASSWORD_RULES: ReadonlyArray<{ label: string; test: (p: string) => boolean }> = [
  { label: `At least ${MIN_LENGTH} characters`, test: (p) => p.length >= MIN_LENGTH },
  { label: 'One lowercase letter (a–z)', test: (p) => /[a-z]/.test(p) },
  { label: 'One uppercase letter (A–Z)', test: (p) => /[A-Z]/.test(p) },
  { label: 'One digit (0–9)', test: (p) => /\d/.test(p) },
];
